import * as React from 'react';

import SignRequest32 from './SignRequest32';

export const signRequest32 = () => <SignRequest32 />;

export default {
    title: 'Icon/Content/SignRequest32',
    component: SignRequest32,
    parameters: {
        notes: "`import SignRequest32 from 'box-ui-elements/es/icon/content/SignRequest32';`",
    },
};
